const TONE_CLASSES = {
  green: "neon-text",
  red: "text-red-400",
  amber: "amber-text",
};

function StatCell({ label, value, tone, testId }) {
  const toneClass = TONE_CLASSES[tone] || "text-white";
  return (
    <div data-testid={testId} className="p-5 border-r border-zinc-800 last:border-r-0">
      <div className="overline">{label}</div>
      <div className={`font-display text-3xl mt-2 ${toneClass}`}>{value}</div>
    </div>
  );
}

export default function TrackerStats({ stats }) {
  if (!stats) return null;
  const pnlPrefix = stats.net_profit >= 0 ? "+" : "";
  const cells = [
    {
      label: "BANKROLL",
      value: `$${stats.current_bankroll.toLocaleString()}`,
      testId: "stat-bankroll",
    },
    {
      label: "NET P/L",
      value: `${pnlPrefix}$${stats.net_profit.toLocaleString()}`,
      tone: stats.net_profit >= 0 ? "green" : "red",
      testId: "stat-pnl",
    },
    { label: "BETS", value: stats.total_bets, testId: "stat-bets" },
    { label: "WIN RATE", value: `${stats.win_rate_pct}%`, testId: "stat-winrate" },
    {
      label: "LOSS STREAK",
      value: stats.current_loss_streak,
      tone: stats.current_loss_streak >= 3 ? "amber" : undefined,
      testId: "stat-streak",
    },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-0 border border-zinc-800 mb-8">
      {cells.map((c) => (
        <StatCell key={c.label} {...c} />
      ))}
    </div>
  );
}
